"use strict";

exports.__esModule = true;
exports.ReportingPeriodController = void 0;
var _react = require("react");
var _URLFilter = require("../../../Core/URLFilter");
var _TimeContext = require("../../TimeContext");
var _timeDefinitions = require("../../../timeDefinitions");
var _dec, _dec2, _class, _ReportingPeriodController;
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var localTimezoneOffset = new Date().getTimezoneOffset() * _timeDefinitions.MINUTE_IN_MILLIS;

/**
 * Provides access to the currently selected reporting period, via a render prop.
 */
var ReportingPeriodController = exports.ReportingPeriodController = (_dec = _URLFilter.URLFilterContext.withContext, _dec2 = _TimeContext.TimeContext.withContext, _dec(_class = _dec2(_class = (_ReportingPeriodController = /*#__PURE__*/function (_Component) {
  function ReportingPeriodController() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportingPeriodController, _Component);
  var _proto = ReportingPeriodController.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      urlFilter = _this$props.urlFilter,
      time = _this$props.time,
      calendar = _this$props.calendar,
      deviceUuid = _this$props.deviceUuid;
    var _urlFilter$filters = urlFilter.filters,
      name = _urlFilter$filters.period,
      term = _urlFilter$filters.term;
    var interval;
    if (name === "shift") {
      if (deviceUuid && calendar) {
        var event = calendar.getEventAt(Date.now(), {
          type: "Shift",
          deviceUUID: deviceUuid
        });
        if (event) {
          interval = event.interval;
        } else {
          interval = time.currentShift.interval;
        }
      } else {
        interval = time.currentShift.interval;
      }
    } else if (name === "workday") {
      // $FlowFixMe
      interval = time.currentWorkday.interval;
    } else {
      var intervalArray = name.split("/");
      interval = {
        startMillis: Date.parse(intervalArray[0]),
        endMillis: Date.parse(intervalArray[1])
      };
    }
    var currentOffsetMillis = time ? time.timezone.currentOffsetMillis : 0;
    var startPlantTime = new Date(interval.startMillis + localTimezoneOffset + currentOffsetMillis);
    var endPlantTime = new Date(interval.endMillis + localTimezoneOffset + currentOffsetMillis);
    return children({
      term: term,
      name: name,
      interval: interval,
      startPlantTime: startPlantTime,
      endPlantTime: endPlantTime
    });
  };
  return ReportingPeriodController;
}(_react.Component), _ReportingPeriodController.defaultProps = {
  urlFilter: undefined,
  time: undefined
}, _ReportingPeriodController)) || _class) || _class);